"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredLineItemGs1BolInfo = void 0;
exports.RequiredLineItemGs1BolInfo = {
    NumberOfPackages: 'NUMBER_OF_PACKAGES',
    PackageWeight: 'PACKAGE_WEIGHT',
    HandlingUnitQuantity: 'HANDLING_UNIT_QUANTITY',
    HandlingUnitType: 'HANDLING_UNIT_TYPE',
    IsPalletizedOrSlipped: 'IS_PALLETIZED_OR_SLIPPED',
    CommodityDescription: 'COMMODITY_DESCRIPTION'
};
//# sourceMappingURL=required-line-item-gs1-bol-info.js.map